<script setup>
import state from "./state";
import {computed, watch, ref, onMounted} from "vue";
import InvoiceEntry from "../components/InvoiceEntry.vue";
import {useRouter} from "vue-router";
import SchemaCollection from "../../components/SchemaCollection";
import validator from "../../components/Validator";
import schemaCollection from "../../components/SchemaCollection";
const router = useRouter();

const errors = ref({});

onMounted(() => {
  state.value.invoiceParticipant = state.value.invoiceParticipant.length > 0 ? state.value.invoiceParticipant : state.value.participants[0];
})

watch(() => state.value.invoicePerson,
    (newValue, oldValue) => {
      if (newValue === 'self') {
        state.value.invoiceContact = state.value.invoiceParticipant;
      } else {
        state.value.invoiceContact = state.value.otherInvoicePerson;
      }
    }
)

watch(() => state.value.invoiceParticipant,
    () => {
      state.value.invoiceContact = state.value.invoiceParticipant;
    }
);

watch(() => state.value.otherInvoicePerson,
    () => {
      state.value.invoiceContact = state.value.otherInvoicePerson;
    }
);

const validate = validator(SchemaCollection.invoiceParticipant, state.value.invoiceContact, errors)
const isInvoiceContactValid = computed( () => {
  if (state.value.invoicePerson === 'self') {
    return SchemaCollection.invoiceParticipant.isValidSync(state.value.invoiceContact);
  } else {
    return SchemaCollection.invoice.isValidSync(state.value.invoiceContact);
  }
})
</script>

<template>
<div>
  <div class="form__title">
    <h2>
      Factuur
    </h2>
  </div>

  <div class="infofield" v-if="state.info.invoiceNotice">
    {{ state.info.invoiceNotice }}
  </div>

  <div class="form-field entry__field">
    <div class="radio-button">
      <input type="radio" id="self" value="self" v-model="state.invoicePerson">
      <label for="self">Cursist betaalt</label>
    </div>
    <div class="radio-button">
      <input type="radio" id="other" value="other" v-model="state.invoicePerson">
      <label for="other">Mijn werkgever betaalt</label>
    </div>
  </div>

  <div v-if="state.invoicePerson === 'self'">
    <div class="entry__field entry__select">
      <label for="invoiceContact">Selecteer een cursist<span class="required-indicator">*</span></label>
      <div class="c-select dropdown-toggle">
        <select name="invoiceContact" id="" v-model="state.invoiceParticipant">
          <option value="" disabled selected>Selecteer een cursist</option>
          <option :value="participant" v-for="(participant, index) in state.participants">
            {{ participant.firstName }} {{ participant.suffix }} {{ participant.lastName }}
          </option>
        </select>
      </div>
    </div>

    <div class="entry__field">
      <label for="invoicePhone">Telefoonnummer<span class="required-indicator">*</span></label>
      <input type="text" v-model="state.invoiceParticipant.phone" id="invoicePhone" @blur="validate('phone')">
      <p class="input-error" v-if="!!errors.phone">
        {{ errors.phone }}
      </p>
    </div>
  </div>

  <div class="entry__field" v-if="state.invoicePerson === 'other'">
    <InvoiceEntry v-model="state.otherInvoicePerson" />
  </div>

  <div class="courseflow-nextbtn">
    <router-link :to="{name: 'confirmation'}" class="button button--green button--form" :class="isInvoiceContactValid ? '' : 'button--disabled'">
      <div class="button__text">
        Bevestigen
      </div>
    </router-link>
  </div>
</div>
</template>